import axiosInt from './axios';

const { default: axios } = require('axios');

const getCancelToken = (useCancelToken = false, cancelToken) => {
  if (!useCancelToken || !cancelToken) return {};
  if (cancelToken.token) return { cancelToken: cancelToken.token };
  return { cancelToken };
};

axios.interceptors.request.use(
  async (config) => {
    // const session = await Auth.currentSession();
    // const token = await session.getIdToken().getJwtToken();
    const token = axiosInt.defaults.headers.common.Authorization;
    if (token) config.headers.Authorization = token;

    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // if (error.response.status === 403) Auth.signOut();

    return Promise.reject(error);
  }
);

export function doPost(
  url,
  payload,
  params,
  headers,
  cancelToken,
  useCancelToken = false
) {
  return new Promise(async (resolve, reject) => {
    axios
      .post(url, payload, {
        params,
        headers,
        ...getCancelToken(useCancelToken, cancelToken)
      })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doGet(
  url,
  params,
  headers,
  cancelToken,
  useCancelToken = false
) {
  return new Promise(async (resolve, reject) => {
    axios
      .get(url, {
        params,
        headers,
        ...getCancelToken(useCancelToken, cancelToken)
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('CANCEL');
          reject(new Error('REQUEST_CANCELLED'));
        }
        reject(err?.response?.data);
      });
  });
}

export function doGetById(
  url,
  params,
  headers,
  cancelToken,
  useCancelToken = false
) {
  return new Promise(async (resolve, reject) => {
    axios
      .get(url, {
        params,
        headers,
        ...getCancelToken(useCancelToken, cancelToken)
      })
      .then(({ data }) => resolve({ ...data }))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doPut(
  url,
  payload,
  params,
  headers,
  cancelToken,
  useCancelToken = false
) {
  return new Promise(async (resolve, reject) => {
    axios
      .put(url, payload, {
        params,
        headers,
        ...getCancelToken(useCancelToken, cancelToken)
      })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doDelete(
  url,
  params,
  headers,
  cancelToken,
  useCancelToken = false
) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(url, {
        params,
        headers,
        ...getCancelToken(useCancelToken, cancelToken)
      })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data));
  });
}

export function doPatch(
  url,
  payload,
  params,
  headers,
  cancelToken,
  useCancelToken = false
) {
  return new Promise(async (resolve, reject) => {
    axios
      .patch(url, payload, {
        params,
        headers,
        ...getCancelToken(useCancelToken, cancelToken)
      })
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err?.response?.data?.message));
  });
}

const ApiCallers = {
  doPost,
  doGet,
  doGetById,
  doPut,
  doPatch,
  doDelete
};

export default ApiCallers;
